'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Popover: ()=>Popover,
    default: ()=>Popover_Popover
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const popover_namespaceObject = require("@base-ui-components/react/popover");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const index_cjs_namespaceObject = require("../IconButton/index.cjs");
const external_ArrowSVG_cjs_namespaceObject = require("./ArrowSVG.cjs");
var external_ArrowSVG_cjs_default = /*#__PURE__*/ __webpack_require__.n(external_ArrowSVG_cjs_namespaceObject);
const external_Popover_variants_cjs_namespaceObject = require("./Popover.variants.cjs");
const external_PopoverContent_cjs_namespaceObject = require("./PopoverContent.cjs");
function Popover({ open = false, onOpenChange, defaultOpen, openOnHover = true, headingCustomNode, headingIconName, headingRightNode, align = 'center', triggerNode, headingText, children, side = 'bottom', ariaLabel, description, footer, showArrow = true, slotClassNames = {}, onClose, hideCloseButton = false, positionerOffset = 8, disableTriggerFocus = false, ...props }) {
    const triggerRef = external_react_default().useRef(null);
    const [isOpen, setIsOpen] = (0, external_react_namespaceObject.useState)(open);
    const noHeading = !headingText && !headingCustomNode;
    const { popupSlot, popupSlotAnimation, arrowSlot, headingSlot, headingCustomSlot, headingLeftSlot, headingRightSlot, headingCloseButtonSlot, headingTextSlot, headingIconSlot, backdropSlot, triggerSlot, bodySlot, bodyTextSlot, scrollAreaSlot, contentSlot, footerSlot, positionerSlot } = (0, external_Popover_variants_cjs_namespaceObject.popoverVariants)({
        customHeader: !!headingCustomNode,
        customFooter: !!footer,
        customBody: !!children,
        noHeading,
        ...props
    });
    const { triggerClass = '', popupClass = '', backdropClass = '', scrollAreaClass = '', bodyClass = '', footerClass = '', contentClass = '', arrowClass = '', headingClass = '', positionerClass = '' } = slotClassNames;
    const triggerClasses = (0, cn_cjs_namespaceObject.cn)(triggerSlot(), triggerClass);
    const popupClasses = (0, cn_cjs_namespaceObject.cn)(popupSlot(), popupSlotAnimation(), popupClass);
    const backdropClasses = (0, cn_cjs_namespaceObject.cn)(backdropSlot(), backdropClass);
    const scrollAreaClasses = (0, cn_cjs_namespaceObject.cn)(scrollAreaSlot(), scrollAreaClass);
    const bodyClasses = (0, cn_cjs_namespaceObject.cn)(bodySlot(), bodyClass);
    const footerClasses = (0, cn_cjs_namespaceObject.cn)(footerSlot(), footerClass);
    const contentClasses = (0, cn_cjs_namespaceObject.cn)(contentSlot(), contentClass);
    const arrowClasses = (0, cn_cjs_namespaceObject.cn)(arrowSlot(), arrowClass);
    const headingClasses = (0, cn_cjs_namespaceObject.cn)(headingSlot(), headingClass);
    const positionerClasses = (0, cn_cjs_namespaceObject.cn)(positionerSlot(), positionerClass);
    const renderCloseButton = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.IconButton, {
            iconName: "close",
            type: "primary",
            shadow: true,
            size: "md",
            "aria-label": "Close popover",
            emphasis: "bold",
            onClick: handleClose
        });
    function handleClose(event) {
        setIsOpen(false);
        onClose?.();
        onOpenChange?.(false, event?.nativeEvent, void 0);
    }
    function handleOpenChange(open, event, reason) {
        setIsOpen(open);
        onOpenChange?.(open, event, reason);
    }
    (0, external_react_namespaceObject.useEffect)(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(popover_namespaceObject.Popover.Root, {
        open: isOpen,
        defaultOpen: defaultOpen,
        openOnHover: openOnHover,
        onOpenChange: handleOpenChange,
        "data-testid": "root",
        children: [
            triggerNode ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Trigger, {
                ref: triggerRef,
                "data-testid": "trigger",
                render: (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: triggerClasses,
                        ...props,
                        ...disableTriggerFocus && {
                            tabIndex: -1
                        },
                        children: triggerNode
                    }),
                children: triggerNode
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(popover_namespaceObject.Popover.Portal, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Backdrop, {
                        className: backdropClasses
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Positioner, {
                        sideOffset: positionerOffset,
                        align: align,
                        side: side,
                        className: positionerClasses,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(popover_namespaceObject.Popover.Popup, {
                            finalFocus: triggerRef,
                            className: popupClasses,
                            "aria-label": ariaLabel,
                            children: [
                                showArrow ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Arrow, {
                                    "data-testid": "arrowSvg",
                                    className: arrowClasses,
                                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ArrowSVG_cjs_default(), {
                                        ...props
                                    })
                                }) : null,
                                noHeading && !hideCloseButton ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                    "data-testid": "noHeadingCloseButton",
                                    className: headingCloseButtonSlot(),
                                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Close, {
                                        render: ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                children: renderCloseButton()
                                            })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PopoverContent_cjs_namespaceObject.PopoverContent, {
                                    headingCustomSlot: headingCustomSlot(),
                                    headingCloseButtonSlot: headingCloseButtonSlot(),
                                    headingLeftSlot: headingLeftSlot(),
                                    headingRightSlot: headingRightSlot(),
                                    headingTextSlot: headingTextSlot(),
                                    headingIconSlot: headingIconSlot(),
                                    bodyTextSlot: bodyTextSlot(),
                                    renderCloseButton: renderCloseButton,
                                    headingCustomNode: headingCustomNode,
                                    headingText: headingText,
                                    headingIconName: headingIconName,
                                    headingRightNode: headingRightNode,
                                    description: description,
                                    footer: footer,
                                    headingClasses: headingClasses,
                                    scrollAreaClasses: scrollAreaClasses,
                                    contentClasses: contentClasses,
                                    bodyClasses: bodyClasses,
                                    footerClasses: footerClasses,
                                    children: children
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const Popover_Popover = Popover;
exports.Popover = __webpack_exports__.Popover;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Popover",
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
